import React from 'react'
import styles from './styles.module.scss'
import DurationDropdown from '../DurationDropdown'

function SectionTitle({ title, normalRightText, showDurationDropdown, selectedDuration, handleDurationChange }) {
  return (
    <div className={styles.sectionTitle}>
      <h2 className={styles.title}>{title}</h2>
      {normalRightText && <div className={styles.rightTitle}>{normalRightText}</div>}
      {showDurationDropdown && (
        <DurationDropdown selectedDuration={selectedDuration} handleDurationChange={handleDurationChange} />
      )}
    </div>
  )
}

export default SectionTitle
